// extracted by mini-css-extract-plugin
export default {"ImgContainer":"RMSEmployeeProfilePicture_ImgContainer__rKz0n"};